import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { isToday } from 'date-fns';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { CarregaJetta } from '../services/carrega_jetta/jetta.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ApiService } from 'src/app/services/contratos/contratos.service';


@Component({
    selector: 'app-carrega-jetta',
    templateUrl: './carrega-jetta.component.html',
    styleUrls: ['./carrega-jetta.component.css'],
    standalone: false
})
export class CarregaJettaComponent implements OnInit {
  items: any[] = [];
  sortColumn: string = '';
  user: string = 'fernando.pazzotti@scania.com';
  senha: string = 'mt139a23';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  routes: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsulta: string = 'https://du0btsv8a3.execute-api.sa-east-1.amazonaws.com/dev22';
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  query: string = 'Pipeline_Inbound';
  data: any;
  dataArray: { [key: string]: string; }[] = [];
  query2: string = 'Itens_Jetta';
  IDJetta: string = '';
  progressCounter: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];
  lastLoadJSL: any;

  constructor(private carregaJetta: CarregaJetta, public dialog: MatDialog, private datePipe: DatePipe, private dynamoDBService: ApiService, private cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    await this.getItemsFromJetta();
    await this.getVeiculosFromDynamoDB();
    await this.getLastLoad();
    // await this.geraJson();
  }

  ngOnDestroy() {
    this.searchTextSubscription?.unsubscribe();
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getLastLoad(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "Itens_Jetta",
        "searchConditions": [
          { "column": "ID", "word": "lastLoadJSL", "negate": false },
          // { "column": "description", "word": "TCM", "negate": false },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          this.lastLoadJSL = items[0].horario;
          // console.log(items )
          // console.log(this.lastLoad )
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async geraJson() {
    //console.log("gera JSON")
    const trip_Json: {
      vehicle: {
        TransportType: string;
        Plate: string;
        cubage: string;
        weightLoaded: string;
        totalCost: string;
        TripSuppliers: { fornecedor: string; janela?: string }[];
        Destination: { destino: string; janelaDestino?: string; passos: number }[];
        TotalDistance: string;
        Passos: number;
        Volumes: number;
        tollCost: number;
      }[];
    } = {
      vehicle: [],
    };
    let destination = '';
    let janelaDestino = ""; // Variável para armazenar a janela
    let janelaDestinoTime = ""; // Variável para armazenar a janela
    let passos = 0; // Variável para armazenar a janela

    for (let i = 0; i < this.items.length; i++) {
      const currentItem = this.items[i];
      // //console.log(currentItem)
      this.IDJetta = currentItem._id;
      for (let j = 0; j < currentItem.routes.length; j++) {
        const currentRoute = currentItem.routes[j];
        const volumes = currentRoute.result.itemsLoaded;
        // //console.log(currentRoute.result.itemsLoaded)
        passos = 0;


        for (let k = 0; k < currentRoute.result.transports.length; k++) {
          let dataHoraObj: Date = new Date;
          let dataHoraObjJanela: Date = new Date;
          let dataHoraObjJanelaStr: string = '';
          let dataHoraObjStr: string = '';
          const currentTransport = currentRoute.result.transports[k];
          const totalDistance = currentRoute.result.distance;
          const fornecedores: { fornecedor: string; janela?: string }[] = [];
          const destinos: { destino: string; passos: number; janelaDestino?: string }[] = [];
          for (let o = 0; o < currentTransport.destinations.length; o++) {
            destination = currentTransport.destinations[o].name;
            // console.log(destination)

            for (let n = 0; n < currentRoute.result.route.schedule.length; n++) {
              if (currentRoute.result.route.schedule[n].name === destination && currentRoute.result.route.schedule[n].id != '10_origem_destino') {
                janelaDestino = currentRoute.result.route.schedule[n].arrivalDate;
                janelaDestinoTime = currentRoute.result.route.schedule[n].arrivalTime;
                // console.log(janelaDestino)
                // console.log(janelaDestinoTime)                
                const horaOriginal = janelaDestinoTime;
                const novaHora = this.removerMultiplosDe24(horaOriginal);
                // console.log(novaHora);                
                // Strings de data e hora
                const dataStr: string = janelaDestino;
                const horaStr: string = novaHora;
                // Convertendo para objetos de data e hora
                const dataObj: Date = new Date(`${dataStr}T00:00:00`);
                const horaObj: Date = new Date(`1970-01-01T${horaStr}`);
                // Exibindo os objetos resultantes
                // console.log("Data:", dataObj.toString()); // Exibe a data em formato ISO
                // console.log("Hora:", horaObj.toTimeString().split(" ")[0]); // Exibe a hora em formato de 24 horas
                // Combinando data e hora em um único objeto
                const dataHoraStr: string = `${dataStr} ${horaStr}`;
                dataHoraObj = new Date(dataHoraStr);
                // console.log("Data e Hora:", dataHoraObj.toString()); // Exibe a data e hora combinadas em formato ISO
                // janelaDestino = currentRoute.result.route.schedule[n].arrivalTime;
                break; // Interrompe o loop assim que encontrar a janela
              }

            }

            // //console.log(currentRoute.result)
            const date1str = this.items[0].date
            const dateObject = new Date(date1str)
            // //console.log(dateObject)            
            const [horas, minutos] = janelaDestino ? janelaDestino.split(':') : '00:00'.split(':');
            // Criar a data atual
            // Somar as horas e minutos à data atual
            dateObject.setHours(dateObject.getHours() + parseInt(horas, 10));
            dateObject.setMinutes(dateObject.getMinutes() + parseInt(minutos, 10));
            // console.log(janelaDestino)
            // //console.log(dateObject.toISOString())
            dataHoraObjStr = this.formatarData2(dataHoraObj)

            passos = passos + 1;
            // await destinos.push({ destino: destination, janelaDestino: dateObject.toISOString(), passos: passos });
            await destinos.push({ destino: destination, janelaDestino: dataHoraObjStr, passos: passos });

          }
          for (let l = 0; l < currentTransport.waypoints.length; l++) {
            const waypoint = currentTransport.waypoints[l];
            let janela = ""; // Variável para armazenar a janela
            let janelaTime = ""; // Variável para armazenar a janela
            for (let m = 0; m < currentRoute.result.route.schedule.length; m++) {
              if (currentRoute.result.route.schedule[m].name === waypoint.name && currentRoute.result.route.schedule[m].id != '10_origem_destino') {
                // janela = currentRoute.result.route.schedule[m].arrivalTime;
                janela = currentRoute.result.route.schedule[m].arrivalDate;
                janelaTime = currentRoute.result.route.schedule[m].arrivalTime;
                // console.log(janelaDestino)
                // console.log(janelaDestinoTime)                
                const horaOriginal = janelaTime;
                const novaHora = this.removerMultiplosDe24(horaOriginal);
                // console.log(novaHora);                
                // Strings de data e hora
                const dataStr: string = janela;
                const horaStr: string = novaHora;
                // Convertendo para objetos de data e hora
                const dataObj: Date = new Date(`${dataStr}T00:00:00`);
                const horaObj: Date = new Date(`1970-01-01T${horaStr}`);
                // Exibindo os objetos resultantes
                // console.log("Data:", dataObj.toString()); // Exibe a data em formato ISO
                // console.log("Hora:", horaObj.toTimeString().split(" ")[0]); // Exibe a hora em formato de 24 horas
                // Combinando data e hora em um único objeto
                const dataHoraStr: string = `${dataStr} ${horaStr}`;
                dataHoraObjJanela = new Date(dataHoraStr);
                break; // Interrompe o loop assim que encontrar a janela
              }
            }
            passos = passos + 1;
            const dateJanelastr = this.items[0].date
            const dateJanelaObject = new Date(dateJanelastr)
            const [horas, minutos] = janela ? janela.split(':') : '00:00'.split(':')
            dateJanelaObject.setHours(dateJanelaObject.getHours() + parseInt(horas, 10));
            dateJanelaObject.setMinutes(dateJanelaObject.getMinutes() + parseInt(minutos, 10));
            // console.log(janela)
            // console.log(dataHoraObjJanela.toString())

            dataHoraObjJanelaStr = this.formatarData2(dataHoraObjJanela)
            // console.log(this.formatarData2(dataHoraObjJanela))
            await fornecedores.push({ fornecedor: waypoint.name, janela: dataHoraObjJanelaStr });

          }
          await trip_Json.vehicle.push({
            TransportType: currentTransport.descricao,
            Plate: currentTransport.plate,
            cubage: currentRoute.result.cubageLoaded,
            weightLoaded: currentRoute.result.weightLoaded,
            totalCost: currentRoute.result.totalCost,
            TripSuppliers: fornecedores,
            Destination: destinos,
            Passos: passos,
            TotalDistance: currentRoute.result.distance,
            Volumes: currentRoute.result.itemsLoaded,
            tollCost: currentRoute.result.tollRoadCost
          });
        }
      }
    }

    const dataArray: { [key: string]: string; }[] = [];

    // Preenche a tabela com os dados
    trip_Json.vehicle.forEach(async (vehicle) => {
      const dataRow: { [key: string]: string } = {
        'Transport Type': vehicle.TransportType,
        'Plate': vehicle.Plate,
        'Cubage': vehicle.cubage,
        'Weight Loaded': vehicle.weightLoaded,
        'Total Cost': vehicle.totalCost,
        'tollCost': vehicle.tollCost.toString(),
        'Total Distance': vehicle.TotalDistance,
        'Passos': vehicle.Passos.toString(),
        'Volumes': vehicle.Volumes.toString(),
        'capacidadePeso': this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType) ? this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType).peso : 0,
        'capacidadeVolumetrica': this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType) ? this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType).volume : 0,
        'veiculoPerfil': this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType) ? this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType).perfil : 'Não encontrado',
        'emissao': this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType) ? this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType).emissoes : 0,
        'consumo': this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType) ? this.veiculos.find(veiculo => veiculo.modelo == vehicle.TransportType).consumo : 0
      };
      // Adiciona as informações dos fornecedores e janelas ao objeto da linha de dados
      vehicle.TripSuppliers.forEach((supplier, index) => {
        const fornecedorKey = `Fornecedor ${index + 1}`;
        const janelaKey = `Janela ${index + 1}`;
        dataRow[fornecedorKey] = supplier.fornecedor;
        dataRow[janelaKey] = supplier.janela ?? '';
      });
      vehicle.Destination.forEach((destinos, index) => {
        const destinoKey = `Destino ${index + 1}`;
        const janelaDestinoKey = `JanelaDestino ${index + 1}`;
        dataRow[destinoKey] = destinos.destino;
        dataRow[janelaDestinoKey] = destinos.janelaDestino ?? '';
      });
      await dataArray.push(dataRow);
    });

    this.dataArray = dataArray;
  }

  removerMultiplosDe24(stringHora: string): string {
    // Parse da string para obter as horas e os minutos
    const [horas, minutos] = stringHora.split(':').map(Number);
    // Conversão total para minutos
    const totalMinutos = horas * 60 + minutos;
    // Remoção de múltiplos de 24 horas
    const minutosSemMultiplos24 = totalMinutos % (24 * 60);
    // Conversão de volta para horas e minutos
    const horasResultantes = Math.floor(minutosSemMultiplos24 / 60);
    const minutosResultantes = minutosSemMultiplos24 % 60;
    // Formatação da nova hora
    const novaHora = `${horasResultantes.toString().padStart(2, '0')}:${minutosResultantes.toString().padStart(2, '0')}`;
    return novaHora;
  }

  formatarData(data: Date): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  formatarData2(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');
    const horas = data.getHours().toString().padStart(2, '0');
    const minutos = data.getMinutes().toString().padStart(2, '0');
    const segundos = data.getSeconds().toString().padStart(2, '0');

    const dataFormatada = `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}.000Z`;

    return dataFormatada;
  }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async salvar() {
    this.isLoading = true;
    await this.geraJson();
    console.log(this.dataArray)
    const currentDate = new Date().getTime();
    this.dataArray.forEach((item: any) => {
      const consumo = parseFloat(item['consumo']);
      const emissao = parseFloat(item['emissao']);
      const distance = parseFloat(item['Total Distance']);
      const peso = parseFloat(item['Weight Loaded']);
      // const emissaoTotal = ((distance / consumo) * (emissao / peso)) * 1000;
      const emissaoTotal = (distance * emissao) / consumo;
      item.emissaoTotal = emissaoTotal;
      item.pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / item.capacidadePeso) * 100) : 0;
      item.cub = this.isValorValido(item.Cubage) ? ((item.Cubage / item.capacidadeVolumetrica) * 100) : 0;
      item.fillingRateMax = Math.max(item.pesoLoaded, item.cub)
    })
    // console.log(this.dataArray)


    const totalItems = this.dataArray.length;
    this.progressCounter = 0;

    // Função recursiva para salvar cada item de forma assíncrona
    const salvarItem = async (index: number) => {
      // //console.log(index)
      if (index >= totalItems) {
        // Todos os itens foram salvos, pode encerrar o processo
        return;
      }

      const data = this.dataArray[index];
      data['tableName'] = this.query2;
      data['created'] = currentDate.toString();
      const finalDate = this.formatarData(new Date());
      data['ID'] = this.IDJetta + index;
      data['description'] = this.items[0].description;
      data['date'] = this.items[0].date;
      const itemsDataString = JSON.stringify(data);
      const modifiedString = itemsDataString.replace(/\\"/g, '"');
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      const modifiedJsonString = JSON.stringify(jsonObject);
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      const jsonArray = [jsonObject2];
      console.log(jsonArray)

      await this.dynamoDBService.salvar(jsonArray, this.query2, this.urlAtualiza).subscribe(
        async response => {
          this.progressCounter++;
          this.isLoading = false;
          // Chamar a função recursiva para salvar o próximo item
          await salvarItem(index + 1);
        },
        async error => {
          console.log(error);
          this.progressCounter++;
          // Chamar a função recursiva para salvar o próximo item
          await salvarItem(index + 1);
        }
      );
    };
    await salvarItem(0);
    await this.salvarCarregamento();
  }

  async salvarCarregamento(){
    this.isLoading = true;
    const dataHora = new Date();
    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/json'
    // });
    let body = [];
    body = [{          
      "ID": 'lastLoadJSL',
      "horario": dataHora.toString(),
      'tableName': this.query2
    }];
    // console.log(body)
    await this.dynamoDBService.salvar(body, this.query2, this.urlAtualiza).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // await this.ngOnInit();
      console.log('Dados salvos com sucesso!')
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
}

  getProgressWidth(): string {
    const totalItems = this.dataArray.length;
    const processedItems = this.progressCounter;
    const progressPercentage = (processedItems / totalItems) * 100;
    return `${progressPercentage}%`;
  }



  converterData(stringData: string): string {
    const partes = stringData.split('/');
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];

    return `${ano}-${mes}-${dia}`;
  }

  aplicarFiltroPorData(): void {
    if (this.filtroDataInicio && this.filtroDataTermino) {
      const filtroInicio = new Date(this.filtroDataInicio);
      const filtroTermino = new Date(this.filtroDataTermino);

      this.itemsFiltrados = this.items.filter(item => {
        const dataFormatada = this.converterData(item.ATA);
        const dataItem = new Date(dataFormatada);

        return dataItem >= filtroInicio && dataItem <= filtroTermino;
      });
    } else {
      this.itemsFiltrados = this.items;
    }
  }

  async getItemsFromJetta(): Promise<void> {
    const filtro = 'Scheduled';
    (await this.carregaJetta.postCredentials(this.user, this.senha)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = response.body.data;
            if (Array.isArray(items)) {
              this.items = items.map(item => ({ ...item, checked: false }));
              this.routes = items.map(item => item.routes); // Obtém os valores da chave 'routes' e atribui a 'routes'
              // console.log(this.routes);
              this.isLoading = false;
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }



}









